import { render, staticRenderFns } from "./ReserveTagEditor.vue?vue&type=template&id=25c2f066&scoped=true"
import script from "./ReserveTagEditor.vue?vue&type=script&lang=js"
export * from "./ReserveTagEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c2f066",
  null
  
)

export default component.exports